import { render, staticRenderFns } from "./newsDetial.vue?vue&type=template&id=3066a81c&scoped=true&"
import script from "./newsDetial.vue?vue&type=script&lang=js&"
export * from "./newsDetial.vue?vue&type=script&lang=js&"
import style0 from "./newsDetial.vue?vue&type=style&index=0&id=3066a81c&lang=less&scoped=true&"
import style1 from "./newsDetial.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066a81c",
  null
  
)

export default component.exports